import { ADD_SUBSCRIPTIONS } from './actions';
import Resource from '../../resource/Resource';

export function addSubscriptions(subscriptions) {
  return (dispatch) => {
    dispatch({
      type: ADD_SUBSCRIPTIONS,
      subscriptions,
    });
  };
}

export function markAllAsRead() {
  return () => {
    return Resource.execute('subscription', 'markAllAsRead');
  };
}

export function updateLastCheckedTime(
  subscriptionId,
  channelId,
  lastCheckedTime
) {
  return () => {
    return Resource.update(
      'subscription',
      subscriptionId,
      'updateLastCheckedTime',
      {
        channelId,
        lastCheckedTime,
      }
    );
  };
}
